import { usePublicConfig } from '@/hooks/api/usePublicConfig';
import { t } from '@/i18n';
import styles from './ProfileSupport.module.css';

export function ProfileSupport() {
  const { data: config } = usePublicConfig();
  const tgUrl = config ? `https://t.me/${config.supportTgUsername}` : '#';
  const mailUrl = `mailto:${t.profile.support.emailAddress}`;

  return (
    <section className={styles.wrap}>
      <div className={styles.card}>
        <div className={styles.title}>{t.profile.support.title}</div>
        <div className={styles.actions}>
          <a
            className={styles.btn}
            href={tgUrl}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className={styles.ico} aria-hidden>
              {String.fromCodePoint(0x2708, 0xfe0f)}
            </span>
            {t.profile.support.telegram}
          </a>
          <a className={styles.btn} href={mailUrl}>
            <span className={styles.ico} aria-hidden>
              {String.fromCodePoint(0x2709, 0xfe0f)}
            </span>
            {t.profile.support.email}
          </a>
        </div>
      </div>
    </section>
  );
}
